import { faSort, faSortDown, faSortUp } from '@fortawesome/pro-solid-svg-icons';
import { StyledSortIcon } from 'components/infinite_data_source_table/styled';
import { memo } from 'react';

type TableSortIconProps = Readonly<{
    /**
     * Whether this column is currently sorted
     */
    isSorted?: boolean;
    /**
     * The current sort direction if sorted
     */
    direction?: 'asc' | 'desc';
}>;

function TableSortIcon({ isSorted, direction }: TableSortIconProps) {
    const sortIcon = isSorted ? (direction === 'asc' ? faSortUp : faSortDown) : faSort;

    return <StyledSortIcon icon={sortIcon} $isSorted={isSorted} />;
}

const memoTableSortIcon = memo(TableSortIcon);
export { memoTableSortIcon as TableSortIcon };
